<template>
  <div class="contribute-wrapper">
    <div v-if="adInfo.picUrl" ref="contributeAdv" @click="handleClickAdv(adInfo.appJump, 3)" class="Advertisement">
      <img ref="image" v-lazy="adInfo.picUrl" />
      <span class="text" v-if="adInfo.label">{{ adInfo.label }}</span>
    </div>
    <main>
      <UserForm ref="contributeForm" @showChooseUnit="handleShowChooseUnit" />
      <div v-if="dataList.length > 0" class="activity-box">
        <div class="info-title">
          <i class="activity-icon"></i>
          <span>参评项目</span>
        </div>
        <div @click="toSelect" class="activity-select">
          <span :style="{ color: selectIndex !== undefined ? '#333333' : '#999999' }">{{
            selectIndex !== undefined ? dataList[selectIndex].name : "请选择"
          }}</span>
          <i class="select-icon"></i>
        </div>
      </div>
      <div v-if="worksTypeList.length > 0" class="activity-box">
        <div class="info-title">
          <i class="worksType-icon"></i>
          <span>项目简称</span>
        </div>
        <div @click="toSelectWorksType" class="activity-select">
          <span :style="{ color: worksTypeIndex !== undefined ? '#333333' : '#999999' }">{{
            worksTypeIndex !== undefined ? worksTypeList[worksTypeIndex].typeName : "请选择"
          }}</span>
          <i class="select-icon"></i>
        </div>
      </div>
      <div class="title-box">
        <div class="info-title">
          <i class="title-icon"></i>
          <span>县(市、区)村或线路</span>
        </div>
        <input type="text" v-model="title" style="text-align: right;width: 80%;" placeholder="9字以内" />
      </div>
      <div class="content-box">
        <div class="info-title">
          <i class="content-icon"></i>
          <span>正文内容</span>
        </div>
        <textarea @input="changeHeight" class="content" v-model="content" placeholder="请输入正文内容(1000字以内)"></textarea>
        <Upload
          :fileList="filesList"
          ref="contributeUpload"
          :fileSizeLimit="fileSizeLimit"
          :limitLength="10"
          :uploadFileType="uploadFileType"
          :beforeChooseFile="beforeChooseFile"
        ></Upload>
      </div>
    </main>
    <footer :class="this.systemInfo.isPhoneX ? 'forIphoneX' : ''" v-if="hidshow">
      <div @click="authorize" class="authorized-box">
        <span v-show="!agree" class="cover-cancel"></span>
        <img v-show="agree" class="cover-confirm" src="../../assets/images/icon_tick_s.png" />
        <input class="authorized" type="checkbox" />
        <!-- <span class="text">我已阅读并同意<a href="javascript:;" class="blue" @click.stop="handleShowContributeInfo">投稿须知</a></span> -->
        <span class="text">申报即同意将资料版权授权给南方+客户端</span>
      </div>
      <button @click="commitInfo" class="commit">提交</button>
    </footer>
    <BottomPicker v-model="select_show" @confirm="handleSel" :dataList="dataList" title="选择项目"></BottomPicker>
    <BottomPicker
      v-model="select_worksType"
      @confirm="handleWorksTypeSel"
      labelKey="typeName"
      :dataList="worksTypeList"
      title="选择项目简称"
    ></BottomPicker>
    <NfAlert
      v-model="alertOptions.show"
      :title="alertOptions.title"
      :content="alertOptions.content"
      @cancel="handleCancel"
      @sure="handleConfirm"
    />
    <Alert :title="contributeInfomationOption.title" :content="contributeInformation" v-model="contributeInfomationOption.show"></Alert>
    <ChooseUnit v-show="showChooseUnit" @close="handleCloseChooseUnit" />
  </div>
</template>

<script>
import Upload from "@/components/Upload"
import BottomPicker from "@/components/BottomPicker"
import Alert from "@/components/Alert"
import UserForm from "./components/UserForm"
import { mapMutations, mapActions, mapGetters } from "vuex"
import advHandlers from "@/mixins/advHandlers"
import { FILE_TYPE_MAP, FORM_ERR_AMP, USER_INFO_KEY_MAP } from "@/dictionary"
import { buryingPoint_contribute, AdvExposure, buryingPoint_click_adv } from "@/server/buryingPoint"
import NfAlert from "@/components/NfAlert"
import ChooseUnit from "@/views/ChooseUnit"
import { getMyWorkDetail } from "@/server/interfaces"

const DEFAULT_UPLOAD_FILE = ["image", "video"]
const DEFAULT_VIDEO_SIZE_LIMIT = 200

export default {
  data() {
    return {
      agree: true,
      select_show: false, //选择活动类型
      select_worksType: false, //选择作品类型
      progressEvent: null,
      title: null,
      mediaFiles: [],
      content: null,
      adInfo: {},
      dataList: [], //活动种类列表数据
      worksTypeList: [], //作品类型列表数据
      selectIndex: undefined, //活动种类选择ID
      worksTypeIndex: undefined, //作品类型选择ID
      userInfo: null,
      edit: false,
      filesList: [],
      jud: true,
      fromMywork: false,
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: "0", //实时屏幕高度
      hidshow: true, //显示或者隐藏footer
      fileSizeLimit: {},
      alertOptions: {
        show: false,
        title: "提示",
        content: "",
        confirmCb: null
      },
      uploadFileType: [],
      beforeChooseFile: null,
      contributeInfomationOption: {
        show: false,
        title: "投稿须知",
        content: ""
      },
      showChooseUnit: false
    }
  },
  mixins: [advHandlers],
  components: {
    Upload,
    BottomPicker,
    NfAlert,
    UserForm,
    Alert,
    ChooseUnit
  },
  mounted() {
    this.docmHeight = document.documentElement.clientHeight
  },
  created() {
    window.onresize = () => {
      return (() => {
        //实时屏幕高度
        this.showHeight = document.body.clientHeight
      })()
    }
    this.executeFuncList()
    buryingPoint_contribute()
    this._getGradeList()
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.hidshow = false
      } else {
        this.hidshow = true
      }
    }
  },
  computed: {
    ...mapGetters({
      activityCategorys: "contribute/activityCategorys",
      worksTypes: "contribute/worksTypes",
      adDetail: "contribute/adDetail",
      commitSuccess: "contribute/commitSuccess",
      editData: "myWork/modifyDetail",
      systemInfo: "systemInfo",
      contributeDefaultOptions: "activityInfo/contributeDefaultOptions",
      contributeInformation: "activityInfo/contributeInformation"
    })
  },
  methods: {
    ...mapMutations({
      toast: "toast/showToast",
      setDefaultOpt: "contribute/setDefaultOpt",
      setUserInfo: "userInfo/setUserInfo"
    }),
    ...mapActions({
      commit: "contribute/commit",
      modify: "contribute/modify",
      getActivityDataList: "contribute/getActivityDataList",
      getAdDetailInfo: "contribute/getAdDetailInfo",
      getGradeList: "activityInfo/getGradeList",
      initDefaultOpt: "contribute/initDefaultOpt"
    }),
    changeHeight(o) {
      o.target.style.height = (o.target.scrollTop + o.target.scrollHeight) / 100 + "rem"
    },
    editCheck() {
      this.edit = this.$route.params.edit
      if (this.edit) {
        this.title = this.workDetail.title
        this.content = this.workDetail.detail
        const imgList = this.workDetail.mediaFiles.map(item => {
          return {
            file: null,
            fileName: "",
            fileSize: "",
            fileType: FILE_TYPE_MAP[item.mediaFileType],
            cover: item.url,
            mediaId: item.mediaId,
            key: item.mediaId
          }
        })
        const videoList = this.workDetail.videos.map(item => {
          return {
            file: null,
            fileName: "",
            fileSize: item.size,
            fileType: FILE_TYPE_MAP[item.mediaFileType],
            cover: item.coverImgUrl,
            mediaId: item.mediaId,
            key: item.mediaId,
            duration: item.duration,
            fileFormat: item.fileFormat || "",
            mdFive: item.mdFive || ""
          }
        })
        this.filesList = [...videoList, ...imgList]
        this.dataList.forEach((item, index) => {
          if (item.name == this.workDetail.activityCategory.name) {
            this.selectIndex = index
            this.setFileLimitSize(item)
          }
        })
        this.worksTypeList.forEach((item, index) => {
          if (item.typeId == this.workDetail.typeId) {
            this.worksTypeIndex = index
            this.uploadFileType = this.resolveUploadFileType(item)
          }
        })
      }
    },
    authorize() {
      this.agree = !this.agree
    },
    toSelect() {
      //选择活动类型
      this.select_show = true
    },
    toSelectWorksType() {
      //选择作品类型
      this.select_worksType = true
    },
    handleSel(selArr) {
      this.resolveChooseActivity(selArr.selItem[0], selArr.selArr[0])
    },
    handleWorksTypeSel(selArr) {
      this.resolveChooseWorkType(selArr.selItem[0], selArr.selArr[0])
    },
    callback(progressEvent) {
      this.progressEvent = progressEvent
    },
    checkHasAllUpload() {
      const uploadFileList = this.$refs.contributeUpload.uploadFileList
      const mediaIds = uploadFileList.filter(item => item.mediaId)
      if (mediaIds.length < uploadFileList.length) {
        this.toast("请确保图片或视频上传完毕再提交")
        return false
      } else {
        return {
          mediaIds: mediaIds
            .filter(item => item.fileType === "image")
            .map(item => ({
              mediaId: item.mediaId
            })),
          videos: mediaIds
            .filter(item => item.fileType === "video")
            .map(item => ({
              mediaId: item.mediaId,
              duration: item.duration,
              size: item.size,
              mdFive: item.mdFive,
              fileFormat: item.fileFormat
            }))
        }
      }
    },
    handleCheckFromData(formData) {
      let hasInputAll = true
      const hasInputInfo = value => {
        let result = true
        const isObject = typeof value === "object"
        if (isObject) {
          const keys = Object.keys(value)
          result = keys.length > 0 && value[keys[0]] !== ""
        } else {
          result = value !== "" && value !== undefined
        }
        return result
      }
      for (let i = 0; i < this.contributeDefaultOptions.length; i++) {
        const key = this.contributeDefaultOptions[i]
        const userKey = USER_INFO_KEY_MAP[key]
        const isPhoneKey = key === "ADVISOR_PHONE"
        if (isPhoneKey) {
          const reg = /^\d{11}$/
          const phone = formData[userKey]
          if (!reg.test(phone)) {
            const errMsg = `联系人手机号不正确`
            this.toast(errMsg)
            return false
          }
        }
        if (key !== "HEAD" && !hasInputInfo(formData[userKey])) {
          const errMsg = FORM_ERR_AMP[key]
          hasInputAll = false
          this.toast(errMsg)
          break
        }
      }
      return hasInputAll
    },
    async commitInfo() {
      const contributeForm = this.$refs.contributeForm.formData
      const formResult = this.handleCheckFromData(contributeForm)
      if (!formResult) return
      if (this.selectIndex === undefined && this.dataList.length > 0) {
        this.toast("请选择项目")
        return
      }
      if (this.worksTypeIndex === undefined && this.worksTypeList.length > 0) {
        this.toast("请选择项目简称")
        return
      }
      if (!this.title) {
        this.toast("请填写县(市、区)村或线路")
        return
      }
      if (!this.content) {
        this.toast("请填写内容")
        return
      }
      if (!this.agree) {
        this.toast("请同意授权")
        return
      }
      const meidiaInfo = this.checkHasAllUpload()
      if (!meidiaInfo) return
      let selectType = this.worksTypeList[this.worksTypeIndex] || {}
      if (selectType.needPic == "YES" && meidiaInfo.mediaIds.length < 1) {
        this.toast("该项目简称需要上传图片")
        return
      }
      if (selectType.needVideo == "YES" && meidiaInfo.videos.length < 1) {
        this.toast("该项目简称需要上传视频")
        return
      }
      let option = {
        params: {
          detail: this.content,
          mediaFiles: meidiaInfo.mediaIds,
          title: this.title,
          videos: meidiaInfo.videos,
          defaultOpt: contributeForm || {}
        }
      }
      if (this.selectIndex !== undefined) {
        option.params.activityCategory = this.dataList[this.selectIndex]
      }
      if (this.worksTypeIndex !== undefined) {
        option.params.typeId = selectType.typeId
      }
      if (this.edit) {
        option.params.id = this.editData.id
        await this.modify(option)
      } else {
        await this.commit(option)
      }
      if (this.commitSuccess) {
        this.toast("提交成功!")
        this.setDefaultOpt(contributeForm)
        this.setUserInfo(contributeForm)
        if (this.fromMywork) {
          this.$router.go(-1)
        } else {
          this.$router.replace("/myWork")
        }
      } else {
        this.toast("提交失败!")
      }
    },
    getMediaId(filesArr) {
      this.mediaFiles = filesArr
    },
    async getActivityCategorys() {
      let option = {
        params: {}
      }
      await this.getActivityDataList(option)
    },
    async getAdDetail() {
      let option = {
        params: {}
      }
      await this.getAdDetailInfo(option)
    },
    async executeFuncList() {
      await this.getActivityCategorys()
      await this._getWorkDetail()
      this.dataList = this.activityCategorys.filter(item => item.display === "YES")
      this.worksTypeList = this.worksTypes.filter(item => {
        return item.display == "YES"
      })
      const defaultOpt = this.workDetail ? this.workDetail.defaultOpt : null
      if (!defaultOpt) {
        this.initDefaultOpt()
      } else {
        this.setDefaultOpt(defaultOpt)
      }
      const hasChildActivity = this.dataList.length > 0
      const hasWorksTypeList = this.worksTypeList.length > 0
      if (!hasChildActivity) {
        this.setFileLimitSize({ videoSize: DEFAULT_VIDEO_SIZE_LIMIT })
      }
      if (!hasWorksTypeList) {
        this.uploadFileType = DEFAULT_UPLOAD_FILE
      }
      this.initBeforeChooseFile(this.dataList)
      this.fromMywork = this.$route.params.conbute
      this.editCheck()
      await this.getAdDetail()
      this.adInfo = this.adDetail || {}
      this.initAdvBuryingPoint()
    },
    judCommit(flag) {
      this.jud = flag
    },
    setFileLimitSize(activityItem) {
      const { videoSize } = activityItem
      videoSize && (this.fileSizeLimit = { video: videoSize })
    },
    resolveChooseActivity(activityItem, selectIndex) {
      const { videoSize } = activityItem
      const oldVideoSize = this.fileSizeLimit.video
      const isSame = oldVideoSize === videoSize
      const hasVideo = !!this.$refs.contributeUpload.uploadFileList.find(item => item.fileType === "video")
      if (!isSame && hasVideo) {
        this.handleShowAlert({ content: "已添加的素材与所选活动要求不一致，若继续将清除已添加的素材" })
        this.selActIndex = selectIndex
        this.selActItem = activityItem
        this.alertOptions.confirmCb = this.handleToggleActivityAlertConfirmCb
      } else {
        this.setFileLimitSize(activityItem)
        this.selectIndex = selectIndex
      }
    },
    resolveChooseWorkType(workTypeItem, selectIndex) {
      const newUploadFileTypeStr = this.resolveUploadFileType(workTypeItem).join("")
      const currentUploadFiles = this.$refs.contributeUpload.uploadFileList.slice(0)
      const currentUploadFileType = resolveCurrentUploadFileType(currentUploadFiles)
      const currentUploadFileTypeStr = currentUploadFileType.join("")
      const isSameUploadFileType = newUploadFileTypeStr.indexOf(currentUploadFileTypeStr) > -1
      const hasUploadFile = !!this.$refs.contributeUpload.uploadFileList.length
      if (!isSameUploadFileType && hasUploadFile) {
        this.handleShowAlert({ content: "已添加的素材与所选作品类型要求不一致，若继续将清除已添加的素材" })
        this.selWorkTypeIndex = selectIndex
        this.selWorkTypeItem = workTypeItem
        this.alertOptions.confirmCb = this.handleToggleWorkTypeAlertConfirmCb
      } else {
        this.uploadFileType = this.resolveUploadFileType(workTypeItem)
        this.worksTypeIndex = selectIndex
      }
      function resolveCurrentUploadFileType(currentUploadFiles) {
        const currentUploadFileType = [
          {
            fileType: "image",
            hasFile: currentUploadFiles.find(item => item.fileType === "image")
          },
          {
            fileType: "video",
            hasFile: currentUploadFiles.find(item => item.fileType === "video")
          }
        ]
        return currentUploadFileType.filter(item => item.hasFile).map(item => item.fileType)
      }
    },
    handleShowAlert(options) {
      Object.assign(this.alertOptions, options)
      this.alertOptions.show = true
    },
    handleCancel() {},
    handleToggleActivityAlertConfirmCb() {
      this.handleClearFiles()
      this.setFileLimitSize(this.selActItem)
      this.selectIndex = this.selActIndex
    },
    handleToggleWorkTypeAlertConfirmCb() {
      this.handleClearFiles()
      this.uploadFileType = this.resolveUploadFileType(this.selWorkTypeItem)
      this.worksTypeIndex = this.selWorkTypeIndex
    },
    handleConfirm() {
      this.alertOptions.confirmCb && this.alertOptions.confirmCb()
    },
    handleClearFiles() {
      this.$refs.contributeUpload.uploadFileList = []
    },
    async _getWorkDetail() {
      const workId = this.$route.query.workId
      if (!workId) return
      const params = {
        id: workId
      }
      try {
        const workDetail = await getMyWorkDetail({ params })
        workDetail.videos = workDetail.videos || []
        workDetail.mediaFiles = workDetail.mediaFiles || []
        this.workDetail = workDetail
      } catch (err) {
        window.console.error(err)
      }
    },
    resolveUploadFileType(workType) {
      const uploadFileType = [
        {
          fileType: "image",
          ban: workType.needPic === "BAN"
        },
        {
          fileType: "video",
          ban: workType.needVideo === "BAN"
        }
      ]
      return uploadFileType.filter(item => !item.ban).map(item => item.fileType)
    },
    initBeforeChooseFile(activityCategorys) {
      const hasActivity = activityCategorys && activityCategorys.length > 0
      if (hasActivity) {
        const _beforeChooseFile = () => {
          const checkChooseActivity = this.selectIndex !== undefined && this.selectIndex !== ""
          if (!checkChooseActivity) {
            this.toast("请先选择项目")
          }
          return checkChooseActivity
        }
        this.beforeChooseFile = _beforeChooseFile
      } else {
        this.beforeChooseFile = null
      }
    },
    _getGradeList() {
      const hasGrade = this.contributeDefaultOptions.includes("GRADE")
      if (hasGrade) {
        this.getGradeList()
      }
    },
    handleShowContributeInfo() {
      this.contributeInfomationOption.show = true
    },
    handleShowChooseUnit() {
      this.showChooseUnit = true
    },
    handleCloseChooseUnit() {
      this.showChooseUnit = false
    },
    initAdvBuryingPoint() {
      this.$nextTick(() => {
        const adv = this.$refs.contributeAdv
        if (adv) {
          const buryingPoint_adv_top_option = {
            action: 23,
            clickPosition: 3
          }
          this.adv_intersectionObserver = new AdvExposure(adv, buryingPoint_adv_top_option)
          this.adv_intersectionObserver.observe()
        }
      })
    },
    unobserveAdvIntersectionObserver() {
      this.adv_intersectionObserver && this.adv_top_intersectionObserver.unobserve()
    },
    destroy() {
      this.unobserveAdvIntersectionObserver()
    },
    handleClickAdv(jumpUrl, clickPosition) {
      buryingPoint_click_adv({
        clickPosition
      })
      this.handleJumpAdvDetail(jumpUrl)
    }
  },
  beforeDestroy() {
    this.destroy()
  }
}
</script>

<style lang="scss" scoped>
.forIphoneX {
  bottom: 34px !important;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #999999;
}

%flex-box-icon {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
}

.cover {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
}

.select-box {
  width: 100%;
  height: 5.54rem;
  background: #fff;
  border-radius: 20px 20px 0 0;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-flow: column nowrap;
  overflow: hidden;
  z-index: 10000;

  h2 {
    width: 100%;
    height: 1.08rem;
    text-align: center;
    border-radius: 20px 20px 0 0;
    font-size: 0.34rem;
    color: #999;
    line-height: 1.08rem;
  }

  .comfirm-box {
    width: 100%;
    height: 0.95rem;
    display: flex;
    background: #fff;
    position: absolute;
    bottom: 0;
    border-top: 1px solid #e3e3e3;

    span {
      height: 100%;
      width: 50%;
      color: #3398ee;
      font-size: 0.3rem;
      line-height: 0.95rem;
      text-align: center;
    }

    span:nth-child(1) {
      border-right: 1px solid #e3e3e3;
    }
  }

  .line {
    width: 100%;
    height: 0.01rem;
    background: #ddd;
    position: absolute;
    top: 2rem;
  }

  .select-container {
    width: 100%;
    height: 100%;
    overflow: hidden;

    .select-item {
      height: 100%;
      overflow: hidden;

      li {
        height: 1rem;
        width: 100%;
        text-align: center;
        font-size: 0.32rem;
        color: #999;
        line-height: 1rem;
      }
    }
  }
}

.Advertisement {
  display: block;
  width: 100%;
  height: 1.48rem;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
  .text {
    display: block;
    width: 0.64rem;
    height: 0.36rem;
    font-size: 0.2rem;
    text-align: center;
    line-height: 0.36rem;
    color: #ffffff;
    letter-spacing: 0;
    position: absolute;
    right: 0.2rem;
    bottom: 0.1rem;
    background: rgba(127, 127, 127, 0.8);
    border-radius: 4px;
  }
}

main {
  .info-title {
    color: #666666;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }

  padding-left: 0.4rem;
  font-size: 0.28rem;
  padding-bottom: 3rem;

  .activity-box,
  .title-box,
  .content-box {
    height: 1rem;
    border-bottom: 1px solid #e3e3e3;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 0.4rem;
  }

  .activity-box {
    .activity-select {
      @extend %flex-box-icon;

      span {
        color: #999999;
      }

      .select-icon {
        display: block;
        width: 0.3rem;
        height: 0.3rem;
        background: url("../../assets/images/icon_arrow.png") no-repeat center;
        background-size: 100%;
        margin-left: 0.2rem;
      }
    }

    .worksType-icon {
      display: block;
      width: 0.28rem;
      height: 0.28rem;
      background: url("../../assets/images/icon_worksType.png") no-repeat center;
      background-size: 100%;
      margin-right: 0.16rem;
    }

    .activity-icon {
      display: block;
      width: 0.28rem;
      height: 0.28rem;
      background: url("../../assets/images/icon_type.png") no-repeat center;
      background-size: 100%;
      margin-right: 0.16rem;
    }
  }

  .title-box {
    .title-icon {
      display: block;
      width: 0.28rem;
      height: 0.28rem;
      background: url("../../assets/images/icon_title.png") no-repeat center;
      background-size: 100%;
      margin-right: 0.16rem;
    }

    input {
      width: 1.3rem;
      height: 100%;
      border: 0;
      display: block;
      outline: none;
      padding-right: 0.1rem;
      color: #333333;
    }
  }

  .content-box {
    height: 100%;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-around;
    align-items: flex-start;
    border: 0;

    .content-icon {
      display: block;
      width: 0.28rem;
      height: 0.28rem;
      background: url("../../assets/images/icon_text.png") no-repeat center;
      background-size: 100%;
      margin-right: 0.16rem;
    }

    .info-title {
      height: 1rem;
      line-height: 1rem;
    }

    .content {
      display: block;
      width: 100%;
      min-height: 2.51rem;
      max-height: 4.18rem;
      border: 1px solid #e3e3e3;
      border-radius: 5px;
      resize: none;
      padding: 0.2rem 0 0 0.14rem;
      outline: none;
      margin-bottom: 0.3rem;
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
      color: #333333;
      -webkit-appearance: none;
    }
  }
}

.movePosition {
  position: static !important;
}

footer {
  width: 100%;
  height: 2.5rem;
  background: linear-gradient(
    to top,
    rgba(255, 255, 255, 1),
    rgba(255, 255, 255, 1) 90%,
    rgba(255, 255, 255, 0.8) 95%,
    rgba(255, 255, 255, 0)
  );
  position: fixed;
  bottom: 0;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  padding: 0.5rem 0.5rem 0.4rem 0.5rem;
  align-items: center;
  z-index: 1001;

  .authorized-box {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    vertical-align: baseline;
    height: 0.3rem;
    line-height: 0.3rem;
    position: relative;

    .cover-confirm {
      width: 0.28rem;
      height: 0.28rem;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -60%);
    }

    .cover-cancel {
      width: 0.28rem;
      height: 0.28rem;
      border: 1px solid #ccc;
      border-radius: 1px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -60%);
    }

    .authorized {
      visibility: hidden;
    }

    .text {
      font-size: 0.22rem;
      color: #919191;
      margin-left: 0.1rem;
    }
  }

  .commit {
    width: 100%;
    height: 0.9rem;
    background: #f64e45;
    border: 0;
    border-radius: 0.45rem;
    color: #fff;
    font-size: 0.28rem;
    text-align: center;
  }
}

.blue {
  color: #389bee;
}
</style>
